export default __webpack_public_path__ + "static/media/setting-icon-active.2d5e63d8.svg";